import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { toast } from "react-toastify";

import { UpdateClientEmployeeCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const ClientEmployeeRecord = () => {
  const navigate = useNavigate();
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  const handleUpdateClientEmployeeSuccess = async () => {
    navigate(
      routes.portal.clients.client.clientEmployees.$buildPath({
        params: { clientId },
      }),
    );
  };

  const handleDeleteSuccess = () => {
    toast.success("Employee deleted successfully");
    navigate(
      routes.portal.clients.client.clientEmployees.$buildPath({
        params: { clientId },
      }),
      {
        viewTransition: true,
        replace: true,
      },
    );
  };

  return (
    <UpdateClientEmployeeCard
      clientId={clientId}
      clientEmployeeId={clientEmployeeId}
      onUpdateClientEmployeeSuccess={handleUpdateClientEmployeeSuccess}
      onDeleteSuccess={handleDeleteSuccess}
    />
  );
};
